module.exports = __webpack_public_path__ + "static/media/project-placeholder.c63f7e35.png";